import React from 'react';
import { Container } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styles from './styles';
import { connect } from 'react-redux';
import * as actions from '../../../actions/adjuntarArchivo';
import * as actionsSnackMensaje from '../../../actions/snackMensaje';
import ArchivosSubidos from '../ArchivosSubidos/ArchivosSubidos';

const ListadoArchivos = (props) => {
    const buscarArchivo = (index, arreglo) => {
        const output = {
            archivo: null,
            index: null,
        };
        let indexBuscado = index;
        let i = 0;
        while (i < arreglo.length) {
            const elemento = arreglo[i];

            if (elemento.bajaLogica) {
                indexBuscado++;
            } else if (indexBuscado === i) {
                output.archivo = elemento;
                output.index = indexBuscado;
                break;
            }

            i++;
        }

        return output;
    };

    const borrarArchivos = (pathArchivo, index) => {
        const respuesta = buscarArchivo(index, props.archivosSubidos);

        if (respuesta.archivo.hasOwnProperty('id')) {
            // baja logica
            const _archivos = props.archivosSubidos.map((elemento) => {
                if (elemento.id === respuesta.archivo.id) {
                    elemento.bajaLogica = true;
                }

                return elemento;
            });

            props.archivosHandler(_archivos);
        } else {
            // eliminacion fisica
            props.eliminarArchivo(
                pathArchivo,
                respuesta.index,
                props.archivosHandler,
                props.archivosSubidos
            );
        }

        const mensajeConfig = {
            mostrarSnack: true,
            mensajeSnack:
                'Archivo borrado con éxito ' + respuesta.archivo.nombreArchivo,
        };
        props.actualizarAtriutoSnackMensaje(mensajeConfig);
    };

    const { classes, archivosSubidos } = props;

    let archivosCargados = null;
    if (archivosSubidos.length > 0) {
        // const habilitacion =
        //     props.seccion === 'facturas' && !props.soloVista
        //         ? !props.deshabilitado
        //         : !props.deshabilitado;
        archivosCargados = (
            <ArchivosSubidos
                fileInfos={archivosSubidos}
                borrarArchivos={borrarArchivos}
                deshabilitado={props.deshabilitado}
            />
        );
    } else {
        return null;
    }

    return (
        <Container disableGutters={true} className={classes.containerAdjuntos}>
            {archivosCargados}
        </Container>
    );
};

const mapStateToProps = (state) => ({
    soloVista: state.nuevaPresentacionReducer.soloVista,
});

const actionCreators = {
    eliminarArchivo: actions.eliminarArchivo,
    actualizarAtriutoSnackMensaje:
        actionsSnackMensaje.actualizarAtriutoSnackMensaje,
};

export default connect(
    mapStateToProps,
    actionCreators
)(withStyles(styles)(ListadoArchivos));
